import { I18N_LANGUAGE_EN, ProductLabel } from '@/constants';
import { Locale } from '@/enums/language';
import { useProductType, useRouteSection } from '@/hooks/useRouteSection';
import { SelectLanguage } from '@/types/GoogleAnalytics/QuotationGA';
import { pushDataLayer } from '@/utility/googleAnalytics';
import { capitalizeFirstChar } from '@/utility/stringUtils';
import { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export default function LanguageSwitcher() {
  const [locale, setLocale] = useState<Locale>(Locale.en);
  const { i18n } = useTranslation();
  const routeSection = useRouteSection();
  const productType = useProductType();
  const productLabel = ProductLabel[productType];

  useEffect(() => {
    setLocale(i18n.language === 'en' ? Locale.en : Locale.my);
  }, [i18n.language]);

  const handleLocaleChange = (locale: Locale) => {
    const lang = locale === Locale.en ? Locale.my : Locale.en;
    lang === Locale.en ? i18n.changeLanguage('en') : i18n.changeLanguage('my');
    setLocale(() => lang);
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip" {...props}>
      {locale === Locale.en ? `Switch to Bahasa Malaysia` : `Switch to English`}
    </Tooltip>
  );

  const handleGA = () => {
    const data: SelectLanguage = {
      event: 'select_language',
      event_category: `${productLabel} - ${capitalizeFirstChar(routeSection)}`,
      event_action: 'Select Language',
      event_label:
        i18n.language === I18N_LANGUAGE_EN ? 'English' : 'Bahasa Melayu',
    };
    pushDataLayer(data);
  };

  return (
    <Wrapper>
      <OverlayTrigger
        placement="left"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        <i
          className="bi bi-globe"
          onClick={() => {
            handleLocaleChange(locale);
            handleGA();
          }}
        >
          <Small>{locale.slice(0, 2)}</Small>
        </i>
      </OverlayTrigger>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-left: 2rem;
  margin-right: 1rem;
  color: #4a5568;
  font-size: 16px;
  cursor: pointer;
  display: inline;

  @media (max-width: 767px) {
    display: block;
    margin-bottom: 1rem; /* Add margin for separation on small screens */
  }
`;

const Small = styled.small`
  font-size: 14px;
`;
